'use client';

import React from 'react';
import { useCurrentOrganization } from '@/core/hooks/useCurrentOrganization';
import { MapBoxView } from './MapView';
import styles from './SituationalAwarenessPage.module.scss';
import { LoadingDataIndicator } from './components/LoadingDataIndicator';
import { MapCopilotControl } from './components/MapCopilotControl';
import { LazyMapDemoControls } from './components/MapDemoControls';
import { PanelResolver } from './components/PanelResolver';
import { RightSidebarDrawer } from './components/RightSidebarDrawer';
import { SubHeaderControls } from './components/SubHeaderControls';
import { TimeFilterControl } from './components/TimeFilterControl';
import { ContextsProviders } from './context/ContextsProviders';

export const SituationalAwarenessPage = () => {
  const { organizationModel } = useCurrentOrganization();

  return (
    <div className={styles.container}>
      <ContextsProviders>
        <SubHeaderControls />
        <div className={styles.pageContent}>
          <MapBoxView /> {/* README: used via "mapRefEl" */}
          {organizationModel?.isDemoControlsAvailable() && <LazyMapDemoControls className={styles.demoPanel} />}
          <RightSidebarDrawer />
          <TimeFilterControl />
          <LoadingDataIndicator />
          <PanelResolver />
          <MapCopilotControl />
        </div>
      </ContextsProviders>
    </div>
  );
};
